import { Box, CircularProgress } from "@mui/material";
import React from "react";

const LoadingComponent = (props) => {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...props}
    >
      <CircularProgress color="error" />
    </Box>
  );
};

export default LoadingComponent;
